import script from "./TeamPanelNavigator.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamPanelNavigator.vue?vue&type=script&setup=true&lang=js"

import "./TeamPanelNavigator.vue?vue&type=style&index=0&id=77d74db9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d74db9"]])

export default __exports__